import React, {
  Component
} from 'react';

import { connect } from 'react-redux'
import { addItems, addFilter } from '../../actions'

import VisibleItems from '../../container/VisibleItems';
import VisibleFilter from '../../container/VisibleFilter';
import sculptures from '../../database/sculptures';

import './App.css'

class App extends Component {

  render() {
    return ( 
      <div className='body'>
        <VisibleFilter />
        <VisibleItems />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  dispatch(addItems({ items: sculptures.items, global: sculptures.items }))
  dispatch(addFilter(sculptures.filter))
  return {}
}


export default connect(null, mapDispatchToProps)(App);
